import { atom, selector } from "recoil"

export const eventTrackerSourceAtom = atom({
  key: "eventTrackerSourceAtom",
  default: {
    chatSource: "server",
    overlaySource: "server",
    pollSource: "server",
    heartAnimSource: "server"
  }
})

export const getEventTrackerSourceCallback = selector({
  key: "getEventTrackerSourceCallback",
  get: ({ getCallback }) => {
    const getReplayActiveStatus = getCallback(({ snapshot }) => async () => {
      const data = await snapshot.getPromise(eventTrackerSourceAtom)
      return data
    })
    return { getReplayActiveStatus }
  }
})